// OurProduct.js - Modern UI with Pill-shaped Explore Buttons
import React from 'react';

const OurProduct = () => {
  const productsData = [
    {
      id: 1,
      badge: "Business Operation",
      name: "Assist Buddi",
      shortDescription: "A unified platform offering customer support, business and project management, event and construction solutions, communication tools, authentication, and voice-based services—all in one place.Designed to streamline operations, improve efficiency, and keep your business connected and scalable.",
      
      url: "https://www.assistbuddi.com/",
      image: "/assests/img/new_assets/buddi.png",
      features: ["Event Management", "Ticket Management", "Analytics Dashboard"]
    },
    {
      id: 2,
      badge: "Ed-tech",
      name: "Simple Shiksha ",
      shortDescription: "A smart and complete solution combining school management and learning systems for institutions and coaching centers.Manage admissions, attendance, fees, academics, and communication while simplifying learning and development with a robust LMS.",
    
      url: "https://business.simpleshiksha.com/",
      image: "/assests/img/new_assets/simpleShikhsaBusiness.png",
      features: ["Student Management", "Fee Automation", "Performance Tracking"]
    }
  ];

  return (
    <section className="foxasir-products-section">
      <div className="products-bg-accent"></div>
      
      <div className="products-container">
        {/* Section Header */}
        <div className="products-header">
          
          <h2 className="products-title">
            Products Built for <span className="title-highlight">Modern Business</span>
          </h2>
          <span className="products-eyebrow">Solutions That Drive Growth</span>
          <p className="products-description">
            Discover enterprise-grade platforms designed to streamline operations, 
            enhance productivity, and accelerate your business growth.
          </p>
        </div>

        {/* Products Grid */}
        <div className="products-grid">
          {productsData.map((product, index) => (
            <div key={product.id} className="product-card-wrapper" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="product-card">
                {/* Card Header with Badge */}
                <div className="product-card-header">
                  <span className="product-badge">{product.badge}</span>
                  <div className="product-icon-placeholder">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      {product.id === 1 ? (
                        <path d="M12 2a10 10 0 1010 10 10 10 0 00-10-10zm0 18a8 8 0 118-8 8 8 0 01-8 8z" />
                      ) : (
                        <path d="M4 4h16v16H4zM8 8h8M8 12h6M8 16h4" />
                      )}
                    </svg>
                  </div>
                </div>

                {/* Product Info */}
                <h3 className="product-name">{product.name}</h3>
                <p className="product-short-description">
                  {product.shortDescription}
                </p>

                {/* Feature Tags */}
                {/* <div className="product-features">
                  {product.features.map((feature, i) => (
                    <span key={i} className="feature-tag">{feature}</span>
                  ))}
                </div> */}

                {/* Pill-shaped CTA Button */}
                <a 
                  href={product.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="product-cta-pill"
                >
                  <span>Explore Product</span>
                  <svg className="cta-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </a>

                {/* Product Image */}
                
              </div>
            </div>
          ))}
        </div>

      
      </div>
    </section>
  );
};

export default OurProduct;